function initFundStickyNavigation() {
  const nav = document.querySelector('.fund-sticky-navigation');
  if (!nav) return;

  const items = nav.querySelectorAll('.fund-sticky-navigation__item');
  if (!items.length) return;

  // Build a map of section ID -> li element
  const sectionMap = new Map();
  items.forEach((item) => {
    const link = item.querySelector('a');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return;
    const id = href.substring(1);
    sectionMap.set(id, item);
  });

  if (!sectionMap.size) return;

  // Collect target elements in DOM order
  const targets = [];
  sectionMap.forEach((item, id) => {
    const el = document.getElementById(id);
    if (el) targets.push({ id, el, item });
  });

  if (!targets.length) return;

  let currentActive = null;

  // Get the Drupal toolbar displacement offset (accounts for admin toolbar when logged in)
  function getToolbarOffset() {
    const displace = getComputedStyle(document.body).getPropertyValue('--drupal-displace-offset-top');
    if (displace) {
      return parseFloat(displace) || 0;
    }
    return 0;
  }

  function setActive(id) {
    if (currentActive === id) return;
    sectionMap.forEach((item) => item.classList.remove('is-active'));
    if (id && sectionMap.has(id)) {
      sectionMap.get(id).classList.add('is-active');

      // Scroll active item into view within the nav list (horizontal only)
      const activeItem = sectionMap.get(id);
      const list = activeItem.closest('.fund-sticky-navigation__list');
      if (list) {
        const listRect = list.getBoundingClientRect();
        const itemRect = activeItem.getBoundingClientRect();
        const scrollLeft = list.scrollLeft + (itemRect.left - listRect.left) - (listRect.width / 2) + (itemRect.width / 2);
        list.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }
    }
    currentActive = id;
  }

  // Mobile accordion toggle
  const toggle = nav.querySelector('.fund-sticky-navigation__toggle');
  if (toggle) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-expanded', !expanded);
    });
  }

  // Activate the first link by default
  setActive(targets[0].id);

  // Calculate total sticky offset (nav + toolbar)
  const navWrapper = document.querySelector('.fund-sticky-navigation-wrapper');
  const getOffset = () => {
    const navHeight = navWrapper ? navWrapper.offsetHeight : 0;
    const toolbarHeight = getToolbarOffset();
    return navHeight + toolbarHeight;
  };

  // Use IntersectionObserver to detect which section is near the top
  // rootMargin must account for both toolbar and nav height
  const topOffset = getOffset();
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActive(entry.target.id);
        }
      });
    },
    {
      rootMargin: `-${topOffset}px 0px -70% 0px`,
      threshold: 0,
    }
  );

  targets.forEach(({ el }) => observer.observe(el));

  // Handle click — smooth scroll with offset
  items.forEach((item) => {
    const link = item.querySelector('a');
    if (!link) return;

    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.getElementById(href.substring(1));
      if (!target) return;

      e.preventDefault();

      // Collapse mobile accordion
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-expanded');
      }

      const offset = getOffset();
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  // Detect sticky state using a sentinel element
  const sentinel = document.querySelector('.fund-sticky-navigation-sentinel');
  if (sentinel && navWrapper) {
    const stickyObserver = new IntersectionObserver(
      ([entry]) => {
        navWrapper.classList.toggle('is-stuck', !entry.isIntersecting);
      },
      { rootMargin: `-${getToolbarOffset()}px 0px 0px 0px`, threshold: 0 }
    );
    stickyObserver.observe(sentinel);
  }
}

window.addEventListener('DOMContentLoaded', () => {
  initFundStickyNavigation();
});
